import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DetailNavigasi } from '../../../models/master-user/detail-navigasi.model';
import { DetailNavigasiApiService } from '../../api/master-user/detail-navigasi.api.service';

@Injectable({
  providedIn: 'root',
})
export class DetailNavigasiDataService {
  constructor(private detailNavigasiApiService: DetailNavigasiApiService) {}

  public getByLogin(loginId: number, query?: string): Observable<DetailNavigasi[]> {
    return this.detailNavigasiApiService.getByLogin(loginId, query);
  }

  public createRecords(loginId: number, navItems: any[]) {
    return this.detailNavigasiApiService.createRecords(loginId, navItems);
  }

  public updateRecords(loginId: number, navItems: any[]) {
    return this.detailNavigasiApiService.updateRecords(loginId, navItems);
  }

  public createNavigasiRegistrasiKlinik(loginId: number, data: any) {
    return this.detailNavigasiApiService.createNavigasiRegistrasiKlinik(loginId, data);
  }
  public getNavRestriction(loginId?: any, refId?: any): Observable<DetailNavigasi[]> {
    return this.detailNavigasiApiService.getNavRestriction(loginId, refId);
  }
}
